import Vue from 'vue'
import Router from 'vue-router'
//import NreFlowTest from '@/components/NreFlowTest'
import MasterPage from '@/components/MasterPage'
import NrePage from '@/components/NrePage'
import FtieMasterPage from '@/components/FtieMasterPage'
import EsMasterPage from '@/components/EsMasterPage'
// import HomePage from '@/components/HomePage'
import TicketHomePage from '@/components/HomePageTicketOverview'
import TicketListView from '@/components/ticket-request-form/TicketListView'
import ETODashboard from '@/components/ETODashboard'
import InventoryDashboard from '@/components/InventoryDashboard'

// ================johnny test start====================================
import CustomLevelReport from '@/components/CustomLevelReport'
// ================johnny test end======================================


import NreFulfillmentDashboard from '@/components/NreFulfillmentDashboard'
import Login from '@/components/Login'
import SuperUserDevLogin from '@/components/SuperUserLogin'
import AzureLogin from '@/components/AzureLogin'
import Callback from '@/components/Callback'

import EsPmSubmitted from '@/components/EsPmSubmitted'
import EsPmSubmitAndReview from '@/components/EsPmSubmitAndReview'
import EsPmLeaderReview from '@/components/EsPmLeaderReview'
import HQSalesReview from '@/components/HQSalesReview'
import SAHeadReview from '@/components/SAHeadReview'
import GRORSMConfirm from '@/components/GRORSMConfirm'
import GROSalesDirectorConfirm from '@/components/GROSalesDirectorConfirm'
import GROHeadConfirm from '@/components/GROHeadConfirm'
import SAHeadConfrim from '@/components/SAHeadConfirm'
import HQSalesConfrim from '@/components/HQSalesConfirm'
import Kickoff from '@/components/Kickoff'
import _FTIEDashboardVue from '@/components/_FTIEDashboard.vue'
import _FTIEPageVue from '@/components/_FTIEPage.vue'
import _RequestFormVue from '@/components/_RequestForm.vue'
import _RequestFormApproval from '@/components/_RequestFormApproval.vue'
// import CustomizePnPage from '@/components/customization-process/CustomizePnPage'
import CustomizationNrePnPage from '@/components/customization-process/CustomizationNrePnPage'
import _AssignRdFunction from '@/components/_AssignRdFunction.vue'
import _ToDoList from '@/components/_ToDoList.vue'
import _RdCheckItem from '@/components/_RdCheckItem.vue'
import RdCheckItemCost from '@/components/fesc-rd-checkitem-nre/RdCheckItemCost.vue'
import _FTIEPageDashboard from '@/components/_FTIEPageDashboard'
import EngineeringServicePageByOptyId from '@/components/engineering-service-process/EngineeringServicePageByOptyId.vue'
import CreateNewEngineeringService from '@/components/engineering-service-process/CreateNewEngineeringService.vue'
import MemberSetting from '@/components/MemberSetting'
import MemberPage from '@/components/MemberPage'
import NRESignFlow from '@/components/NRESignFlow'
import RoleSetting from '@/components/RoleSetting'
import MemberSettingAddISR from '@/components/MemberSettingAddISR'
import MemberSettingAddGRO from '@/components/MemberSettingAddGRO'

import TaskDashboard from '@/components/task-management/TaskDashboard.vue'
// import TaskPageByTaskId from '@/components/task-management/TaskPage.vue'
import TaskPageByTaskId from '@/components/task-management/TaskMasterPage.vue'
import EngineeringServiceDashboard from '@/components/engineering-service-process/EngineeringServiceDashboard.vue'
import FTIEOpenAIChat from '@/components/framework-gen-ai/FTIEOpenAIChat.vue'
import FTIEAINavigator from '@/components/framework-gen-ai/FTIEAINavigator.vue'
import PdcAINavigator from '@/components/framework-gen-ai/PdcAINavigator.vue'
import CustomizationTvoAgent from '@/components/framework-gen-ai/FTIETVOAgent.vue'
import CSPReport from '@/components/CSPReport.vue'
import FtieAssignSetting from '@/components/FtieAssignSetting.vue'
import FTIEInventoryPage from '@/components/unique-compo-inventory/FTIEInventoryPage'
import ComponentInventoryPage from '@/components/unique-compo-inventory/ComponentInventoryPage'
import CustomDescDashboard from '@/components/CustomDescDashboard.vue'
import OptyDashboard from '@/components/opty-management/OptyDashboard.vue'
import OptyPage from '@/components/opty-management/OptyPage.vue'
import SalesforceReportPage from '@/components/framework-sfdc/SfdcReportDisplay.vue'
// import AccountPage from '@/components/opty-management/AccountPage.vue'
import AccountPageById from '@/components/opty-management/AccountMasterPage.vue'
import DemoLoanPage from '@/components/opty-management/DemoLoanMasterPage.vue'

// test LangGraph AI
import AgenticGraphChat from '@/components/framework-gen-ai/GraphAgenticFlow.vue'
// eQuote AI — Product Spec Generator
import ProductSpecGenerator from '@/components/framework-gen-ai/ProductSpecGenerator.vue'

Vue.use(Router)

/* 權限控制於 src/main.js */

function getChildProps(route) {
  return _.last(route.matched).props.default;
}

export default new Router({
  mode: 'history',
  hash: false,
  routes: [
    {
      path: '/',
      redirect: '/azure-login',
    },
    {
      path: '/login',
      redirect: '/azure-login',
    },
    {
      path: '/admin-login',
      name: 'Login',
      component: Login
    },
    {
      path: '/admin-login-dev',
      name: 'Login',
      component: SuperUserDevLogin
    },
    {
      path: '/azure-login',
      name: 'AzureLogin',
      component: AzureLogin
    },
    {
      path: '/callback',
      name: 'callback',
      component: Callback
    },
    {
      path: '/ftie/request-form-approval/:request_form_id',
      name: 'RequestFormApproval',
      component: _RequestFormApproval,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/',
      name: 'MasterPage',
      component: MasterPage,
      children: [
        {
          path: '/log/csp/report-only',
          name: 'CSPReport',
          component: CSPReport
        },
        {
          path: '/homepage',
          name: 'HomePage',
          component: TicketHomePage,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/home',
          name: 'Home',
          component: TicketHomePage,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/gen-ai',
          name: 'GenAI',
          component: FTIEOpenAIChat,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/agentic-ai',
          name: 'AgentChat',
          component: AgenticGraphChat,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/product-spec',
          name: 'ProductSpecGenerator',
          component: ProductSpecGenerator,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: ETODashboard,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/dashboard/:keywords',
          name: 'Dashboard',
          component: ETODashboard,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/dashboard/nre-id/:nreId',
          name: 'Dashboard',
          component: ETODashboard,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/inventory',
          name: 'Inventory',
          component: InventoryDashboard,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/inventory/ftie/:ftieId',
          name: 'FTIEInventoryPage',
          component: FTIEInventoryPage,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/inventory/component_pn/:pn',
          name: 'ComponentInventoryPage',
          component: ComponentInventoryPage,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/custom-desc-dashboard',
          name: 'CustomDescDashboard',
          component: CustomDescDashboard,
          meta: {
            requireAuth: true
          }
        },
        // =====================johnny test start====================================================================
        {
          path: '/custom-level-report',
          name: 'Custom Level Report',
          component: CustomLevelReport,
          meta: {
            requireAuth: true
          }
        },
        // =====================johnny test end======================================================================



        {
          path: '/inventory/:keywords',
          name: 'Inventory',
          component: InventoryDashboard,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/nre-fulfillment',
          name: 'Fulfillment',
          component: NreFulfillmentDashboard,
          meta: {
            requireAuth: true
          }
        },
        // region: ftie pages
        {
          path: '/ftie/list-view',
          name: 'List View',
          component: TicketListView,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/ftie/ftie-dashboard',
          name: 'FTIE Dashboard',
          component: _FTIEDashboardVue,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/ftie/ai-overview',
          name: 'FTIE AI Overview',
          component: FTIEAINavigator,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/pdc/ai-overview',
          name: 'PDC AI Overview',
          component: PdcAINavigator,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/ftie/tvo-ai-agent',
          name: 'FTIE TVO AI Agent',
          component: CustomizationTvoAgent,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/ftie/ftie-dashboard/ftie-id/:ftieId',
          name: 'FTIE Dashboard',
          component: _FTIEDashboardVue,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/ftie/ftie-page/:ftie_id',
          name: 'FTIE Page',
          component: _FTIEPageVue,
          meta: {
            requireAuth: true
          }
        },

        {
          path: '/ftie/request-form/:ftie_id',
          name: 'Request Form',
          component: _RequestFormVue,
          meta: {
            requireAuth: false
          }
        },
        {
          path: '/ftie/ftie-page-dashboard',
          name: 'FTIE Page Dashboard',
          component: _FTIEPageDashboard,
          meta: {
            requireAuth: true
          }
        },

        // TO BE CHECK: DO WE STILL USE THIS COMPONENTS? OR WE RPLACE TO COMPONENTS-MemberPage.vue
//        {
//          path: '/ftie/assign-dashboard',
//          name: 'Assign Dashboard',
//          component: _AssignDashboard,
//          meta: {
//            requireAuth: true
//          }
//        },

        {
          path: '/ftie/ftie-page-dashboard/ftie-id/:ftieId',
          name: 'FTIE Page Dashboard',
          component: _FTIEPageDashboard,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/ftie/assign-rd-function/:ftie_id/:request_form_id',
          name: 'Assign RD Function',
          component: _AssignRdFunction,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/ftie/to-do-list',
          name: 'To Do List',
          component: _ToDoList,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/ftie/rd-check-item/:ftie_id/:request_form_id',
          name: 'RD Check Item',
          component: _RdCheckItem,
          meta: {
            requireAuth: true
          }
        },

        {
          path: '/ftie/rd-check-item-nre/:ftie_id/:request_form_id',
          name: 'RD Check Item and NRE',
          component: RdCheckItemCost,
          meta: {
            requireAuth: true
          }
        },
        // endregion: ftie pages
        //  region: salesforce task management --- task dashboard
        {
          path: '/task/dashboard',
          name: 'Task Dashboard',
          component: TaskDashboard,
          meta: {
            requireAuth: true
          }
        },
        // region: salesforce task management --- SINGEL TASK PAGE
        {
          path: '/task/task-id/:task_id',
          name: 'Task Master Page',
          component: TaskPageByTaskId,
          meta: {
            requireAuth: true
          }
        },
        // endregion: salesforce task
        {
          path: '/opportunity/dashboard',
          name: 'Opportunity Dashboard',
          component: OptyDashboard,
          meta: {
            requireAuth: true
          }
        },
        // region: salesforce opty detail page
        {
          path: '/opportunity/opty-id/:opty_id',
          name: 'Opty Page',
          component: OptyPage,
          meta: {
            requireAuth: true
          }
        },
        // endregion
        // region: salesforce account detail page
        {
          path: '/opportunity/demo-loan/id/:demo_loan_id',
          name: 'Demo Loan Master Page',
          component: DemoLoanPage,
          meta: {
            requireAuth: true
          }
        },
        // endregion
        // region: salesforce account detail page
        {
          path: '/opportunity/account-id/:account_id',
          name: 'Account Master Page',
          component: AccountPageById,
          meta: {
            requireAuth: true
          }
        },
        // endregion
        // region: salesforce report detail and downloading page
        {
          path: '/salesforce/report/report-id/:report_id',
          name: 'Salesforce Report Page',
          component: SalesforceReportPage,
          meta: {
            requireAuth: true
          }
        },
        // endregion
        // region: es ticket dashboard
        {
          path: '/engineering-services/dashboard',
          name: 'Engineering Service Dashboard',
          component: EngineeringServiceDashboard,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/engineering-services/dashboard/search/:searchBy/:searchContent',
          name: 'Engineering Service Dashboard',
          component: EngineeringServiceDashboard,
          meta: {
            requireAuth: true
          }
        },
        // endregion: es ticket dashboard

        // region: member settings

        {
          path: '/admin-member/setting-update',
          name: 'Member Page',
          component: MemberPage,
          props: getChildProps,
          children: [
            {
              path: '/admin-member/setting',
              name: 'Member Settings',
              component: MemberSetting,
              meta: {
                requireAuth: true
              }
            },
            {
              path: '/admin-member/nre-signflow',
              name: 'Member Settings',
              component: NRESignFlow,
              meta: {
                requireAuth: true
              }
            },
            {
              path: '/admin-member/manager-group',
              name: 'Member Settings',
              component: RoleSetting,
              meta: {
                requireAuth: true
              }
            },
            {
              path: '/admin-member/setting-addisr',
              name: 'Member Settings',
              component: MemberSettingAddISR,
              meta: {
                requireAuth: true
              }
            },
            {
              path: '/admin-member/setting-addgro',
              name: 'Member Settings',
              component: MemberSettingAddGRO,
              meta: {
                requireAuth: true
              }
            },
            {
              path: '/admin-member/setting-assignFtie',
              name: 'Member Settings',
              component: FtieAssignSetting,
              meta: {
                requireAuth: true
              }
            }

          ]
        },

        // endregion: member settings

      ]
    },
    // endregion: member settings for separates features
    // region: salesforce task management
    /**
     *
         {
          path: '/task',
          name: 'EsMasterPage',
          component: EsMasterPage,
          props: getChildProps,
          children: [
            {
              path: '/task/task-id/:task_id',
              name: 'Task Detail by Task ID',
              component: TaskPageByTaskId,
              meta: {
                requireAuth: true
              }
            },
          ]
        },
     */

    // end region
    {
      path: '/engineering-service',
      name: 'EsMasterPage',
      component: EsMasterPage,
      props: getChildProps,
      children: [
        {
          path: '/engineering-service/new',
          name: 'New Engineering Service',
          component: CreateNewEngineeringService,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/engineering-service/new/:opty_id',
          name: 'New Engineering Service',
          component: CreateNewEngineeringService,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/engineering-service/opty-id/:opty_id',
          name: 'ES Detail by Opty ID',
          component: EngineeringServicePageByOptyId,
          meta: {
            requireAuth: true
          }
        },
      ]
    },

    {
      path: '/nre',
      name: 'CustomizationNrePnPage',
      component: FtieMasterPage,
      props: getChildProps,
      children: [
        {
          path: 'customization-nre-pn/:ftie_id/:detail_id/:request_form_id',
          name: 'Customization NRE PN',
          component: CustomizationNrePnPage,
          meta: {
            requireAuth: true
          }
        },
      ]
    },

    {
      path: '/',
      name: 'NrePage',
      component: NrePage,
      props: getChildProps,
      children: [
        {
          path: 'espm-submitted/:ftie_id/:sku_id/:nre_id/:real_sku_no/:create_by',
          name: 'ES PM Submitted',
          component: EsPmSubmitted,
          props: { stageKey: 'stage-10', stageApiBase: 'stage-management', stageApiName: 'espm-submitted', currencyDisabled: false },
          meta: {
            requireAuth: true    // 表示必须要登录
          }
        },
        //EsPmSubmitAndReview ES PM can view what power submit
        {
          path: 'espm-submitted-and-review/:ftie_id/:sku_id/:nre_id/:real_sku_no/:create_by',
          name: 'ES PM Submitted and Reviewed',
          component: EsPmSubmitAndReview,
          props: { stageKey: 'stage-10', stageApiBase: 'stage-management', stageApiName: 'espm-submitted', currencyDisabled: false },
          meta: {
            requireAuth: true    // 表示必须要登录
          }
        },

        {
          path: 'espm-leader-review/:ftie_id/:sku_id/:nre_id/:real_sku_no/:create_by',
          name: 'ES PM Head Review',
          component: EsPmLeaderReview,
          props: { stageKey: 'stage-20', stageApiBase: 'stage-management', stageApiName: 'espm-head-review', currencyDisabled: false },
          meta: {
            requireAuth: true    // 表示必须要登录
          }
        },
        {
          path: 'hq-sales-review/:ftie_id/:sku_id/:nre_id/:real_sku_no/:create_by',
          name: 'HQ Sales Review',
          component: HQSalesReview,
          props: { stageKey: 'stage-30', stageApiBase: 'stage-management', stageApiName: 'hq-sales-review' },
          meta: {
            requireAuth: true    // 表示必须要登录
          }
        },
        {
          path: 'sa-head-review/:ftie_id/:sku_id/:nre_id/:real_sku_no/:create_by',
          name: 'SA Head Review',
          component: SAHeadReview,
          props: { stageKey: 'stage-40', stageApiBase: 'stage-management', stageApiName: 'sa-head-review' },
          meta: {
            requireAuth: true    // 表示必须要登录
          }
        },
        //rsm-confirm
        {
          path: 'rsm-confirm/:ftie_id/:sku_id/:nre_id/:real_sku_no/:create_by',
          name: 'RSM Confirmation',
          component: GRORSMConfirm,
          props: { stageKey: 'stage-50', stageApiBase: 'stage-management', stageApiName: 'rsm-confirm' },
          meta: {
            requireAuth: true    // 表示必须要登录
          }
        },
        {
          path: 'sales-director-confirm/:ftie_id/:sku_id/:nre_id/:real_sku_no/:create_by',
          name: 'Sales Director Confirmation',
          component: GROSalesDirectorConfirm,
          props: { stageKey: 'stage-60', stageApiBase: 'stage-management', stageApiName: 'sales-director-confirm' },
          meta: {
            requireAuth: true    // 表示必须要登录
          }
        },
        {
          path: 'gro-head-confirm/:ftie_id/:sku_id/:nre_id/:real_sku_no/:create_by',
          name: 'GRO Head Confirmation',
          component: GROHeadConfirm,
          props: { stageKey: 'stage-65', stageApiBase: 'stage-management', stageApiName: 'gro-head-confirm' },
          meta: {
            requireAuth: true    // 表示必须要登录
          }
        },
        {
          path: 'sa-head-confirm/:ftie_id/:sku_id/:nre_id/:real_sku_no/:create_by',
          name: 'SA Head Confirmation',
          component: SAHeadConfrim,
          props: { stageKey: 'stage-70', stageApiBase: 'stage-management', stageApiName: 'sa-head-confirm' },
          meta: {
            requireAuth: true    // 表示必须要登录
          }
        },
        {
          path: 'hq-sales-confirm/:ftie_id/:sku_id/:nre_id/:real_sku_no/:create_by',
          name: 'HQ Sales Confirmation',
          component: HQSalesConfrim,
          props: { stageKey: 'stage-80', stageApiBase: 'stage-management', stageApiName: 'hq-sales-confirm' },
          meta: {
            requireAuth: true    // 表示必须要登录
          }
        },
        {
          path: 'espm-kickoff/:ftie_id/:sku_id/:nre_id/:real_sku_no/:create_by',
          name: 'ES PM Project Kickoff',
          component: Kickoff,
          props: { stageKey: 'stage-90', stageApiBase: 'stage-management', stageApiName: 'espm-kickoff' },
          meta: {
            requireAuth: true    // 表示必须要登录
          }
        }
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js